import React from 'react';
import { CTAButton } from './CTAButton';
export function PurchaseSection() {
  return <section id="compra" className="py-5 px-4 bg-black text-white text-center" data-id="element-261">
      <div className="max-w-4xl mx-auto" data-id="element-262">
        <h2 className="text-[20px] font-black mb-2 text-[#9D7FE0]" data-id="element-263">
          ACCEDÉ AHORA A EFEMÉRIDES LISTAS SECUNDARIA
        </h2>

        <ul className="text-lg md:text-xl font-medium mb-4 max-w-xl mx-auto text-left space-y-1.5" data-id="element-264">
          <li className="flex items-start" data-id="element-265">
            <span className="text-[#9D7FE0] mr-2 font-bold" data-id="element-266">•</span> Efemérides
            Listas Secundaria
          </li>
          <li className="flex items-start" data-id="element-267">
            <span className="text-[#9D7FE0] mr-2 font-bold" data-id="element-268">•</span> BONUS 1:
            Banco de Producciones Escritas
          </li>
          <li className="flex items-start" data-id="element-269">
            <span className="text-[#9D7FE0] mr-2 font-bold" data-id="element-270">•</span> BONUS 2:
            Banco de Debates para Secundaria
          </li>
          <li className="flex items-start" data-id="element-271">
            <span className="text-[#9D7FE0] mr-2 font-bold" data-id="element-272">•</span> BONUS 3: 50
            Actividades de Ciudadanía
          </li>
          <li className="flex items-start" data-id="element-273">
            <span className="text-[#9D7FE0] mr-2 font-bold" data-id="element-274">•</span> BONUS 4:
            Del Aula al Mundo
          </li>
        </ul>

        <div className="flex justify-center mb-3" data-id="element-275">
          <img src="https://cdn.magicpatterns.com/uploads/btwBdfKU2FmRHXuQeh4xLo/ChatGPT_Image_6_jun_2026,_11_08_46_p.m..png" alt="Efemérides Listas Secundaria + Todos los bonus" className="w-full max-w-[320px] h-auto object-contain drop-shadow-2xl rounded-lg" data-id="element-276" />
        </div>

        <div className="mb-3" data-id="element-277">
          <p className="text-gray-400 text-lg uppercase tracking-widest font-bold mb-1" data-id="element-278">
            EFEMÉRIDES LISTAS SECUNDARIA + TODOS LOS BONUS
            <br data-id="element-279" />
            PRECIO ÚNICO
          </p>
          <p className="text-6xl md:text-7xl font-black text-white mb-2" data-id="element-280">
            ARS $19.990
          </p>
        </div>

        <div className="bg-gray-900 p-5 md:p-8 rounded-3xl border-2 border-gray-800 shadow-2xl max-w-2xl mx-auto" data-id="element-281">
          <p className="text-2xl md:text-3xl font-black text-white mb-5" data-id="element-282">
            👉 QUIERO MI EFEMÉRIDES LISTAS SECUNDARIA
          </p>

          <CTAButton href="https://checkout.aula-mater.online/cart/66833645535277:1" className="w-full text-xl md:text-2xl py-6 mb-4 flex items-center justify-center gap-3" data-id="element-283">
            <img src="https://cdn.magicpatterns.com/uploads/1zsZUAsENUbyjUUgU5zi4q/728fb7bc-1af5-4646-a10e-52053b14ff22.png" alt="Shopify" className="w-11 h-11 flex-shrink-0 object-contain brightness-0 invert" data-id="element-284" />
            COMPRA AUTOMÁTICA
          </CTAButton>

          <CTAButton href="https://wa.me/5491124676057?text=Hola%20te%20hablo%20por%20el%20material%20de%20Efemerides%20Listas%20Secundaria%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion." className="w-full text-xl md:text-2xl py-6 mb-4 flex items-center justify-center gap-3 !bg-gradient-to-r !from-[#25D366] !to-[#128C7E] !shadow-[0_0_20px_rgba(37,211,102,0.4)]" data-id="element-285">
            <svg className="w-7 h-7 flex-shrink-0" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-id="element-286">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-287" />
            </svg>
            COMPRA POR WHATSAPP
          </CTAButton>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm md:text-base font-bold text-gray-300 mt-2" data-id="element-288">
            <span className="flex items-center" data-id="element-289">
              <span className="text-green-500 mr-2" data-id="element-290">✔</span> Secundaria
            </span>
            <span className="flex items-center" data-id="element-291">
              <span className="text-green-500 mr-2" data-id="element-292">✔</span> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-293">
              <span className="text-green-500 mr-2" data-id="element-294">✔</span> Descarga digital
            </span>
            <span className="flex items-center" data-id="element-295">
              <span className="text-green-500 mr-2" data-id="element-296">✔</span> Material
              organizado por mes
            </span>
            <span className="flex items-center" data-id="element-297">
              <span className="text-green-500 mr-2" data-id="element-298">✔</span> Recursos para todo
              el ciclo lectivo
            </span>
          </div>
        </div>

        <div className="mt-4 max-w-2xl mx-auto" data-id="element-299">
          <p className="text-sm text-gray-400" data-id="element-300"></p>
          <p className="text-sm text-gray-400 mt-1" data-id="element-301"></p>
        </div>
      </div>
    </section>;
}